import { Component, OnInit } from '@angular/core'
import { NavigateService } from '../../service/navigate.service'
import { Router } from '@angular/router'
declare var $: any
@Component({
  selector: 'app-about-index',
  templateUrl: './about-index.component.html',
  styleUrls: [
    './about-index.component.styl',
    '../../share/breadcrumb/breadcrumb.component.styl',
    './media.css',
  ],
})
export class AboutIndexComponent implements OnInit {
  navRightActive: any = [true, false, false, false, false, false]
  listener: any = null
  status: boolean = true //防抖标志;
  peopleListOne: any = {}
  peopleList: any = []
  peopleList2: any = []
  leaderList3: any = []
  peopleList3: any = []
  leaderList4: any = []
  peopleList4: any = []
  leaderList5: any = []
  peopleList5: any = []
  leaderList6: any = []
  leaderList7: any = []
  peopleList7: any = []
  leaderList8: any = []
  peopleList8: any = []
  leaderList9: any = []
  peopleList9: any = []
  leaderList10: any = []
  peopleList10: any = []
  leaderList11: any = []
  peopleList11: any = []
  leaderList12: any = []
  peopleList12: any = []
  leaderListElection: any = []
  currentName: any = null
  top: any = null
  fun: any = null
  fun1: any = null
  constructor(
    private navigateService: NavigateService,
    private router: Router
  ) {
    this.peopleListOne = {
      titlebg: '../../../assets/img/about_people_detail_00.png',
      bgSrc: '../../../assets/img/about_people_detail_02.png',
      src: '../../../assets/img/about_people_02.png',
      name: 'Della Cheng 成小凤',
      title:
        'Director of AP Programs',
      position: 'Chairwoman',
      des: 'HD Schools',
      date: '2023 – 2025',
      experience:
        'Della Cheng, currently as the Director of AP Programs,HD Schools, who had worked in Ningbo Foreign Language School as Director of College Counseling over 14 years, is one of the first generation of the school-based college counselors in China. In April 2023, she is elected as the President of ChinaICAC, the biggest community of college admission counseling in China. Currently she is invited as the committee member of UChicago’s Phoenix League Advisory Board and OSU’s High School Counselor Advisory Board. Previously she was served both in the committee member of Mentor Committee of IACAC ( International Association of College Admission Counseling) and invited for two rounds as one of 13 members globally for International Advisory Committee by Collegeboard. For years, she has been actively engaged in the development of college counseling profession especially in China. She is also certified as the Career Advisor of IACA(International Association of Career Advisors). With over fourteen years’ management experience of international education and college counseling, she has devoted wholeheartedly herself in counseling and AP programs and developed a comprehensive college counseling program specialized in the communication with parents and students.She is entitled as the expert counselor by using AP curriculum to apply internationally. Acknowledged by lots of admission officers from many universities and colleges from the world, she and her counseling team have fulfilled their students’ dreams into their best fit universities.',
    }
    this.peopleList = [
      {
        bgSrc: '../../../assets/img/about_people_bg_126.png',
        src: '../../../assets/img/about_people_126.png',
        src2: '../../../assets/img/new/26.png',
        name: 'Amy Zou 邹培',
        title: 'Coordinator of College Counseling，\nAP Coordinator',
        des: 'Tsinghua International School ',
        date: '2023 – 2025',
        experience: `Has been working at Tsinghua International School since 2010 and is now serving as the Coordinator of College Counseling and the AP Coordinator. Over the past 12 years, Amy has guided students from different cultural backgrounds to universities worldwide, not only as a college counselor but as a lifelong learner, seeking opportunities to learn more about career advising and mental health counseling strategies and skills. She achieved the Certificate of College Counseling at UCLA extension in 2017, the Career Advisor Certificate from the International Association of Career Advisors in 2019, and is working on a social psychology program at Tsinghua University. `,
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_10.png',
        src: '../../../assets/img/about_people_10.png',
        name: 'Francis Miller 陈泽汉',
        title: 'Director of College Counseling',
        des: "Xi'an Tie Yi High School",
        date: '2023 – 2025',
        experience:
          'Francis Miller is a director of college counseling at Xi’an Tie Yi High School in Shaanxi Province, China, since 2018. He holds membership with International ACAC and ChinaICAC, where he volunteers on the membership committees for both organizations. He also writes articles for the Cialfo Community as a Counselor in Residence. Since moving to Xi’an, he has served as a Citizen Liaison Volunteer in Xi’an for the U.S. Embassy in Beijing. \n\nHe studied Chinese language at Tsinghua University as a Foreign Language Area Studies fellow supported by the U.S. Department of Education. He received his B.A. and M.A. from the University of Pennsylvania. He is an avid bicyclist and restaurant reviewer for the English magazine Xianease.',
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_108.png',
        src: '../../../assets/img/about_people_108.png',
        name: 'Fran Liu 刘芳远',
        title: 'Director, China Office',
        des: 'University of Minnesota',
        date: '2022 – 2023',
        experience:
          "Fran Liu joined the University of Minnesota (U of M) China Office in 2019. Her work focuses on advancing the University brand systemwide by sharing U of M information with prospective students and families, engaging the Chinese alumni communities, and developing educational collaborations between the University and its partners in China. \n\nAs the University representative office in China, Fran and her team have achieved a 15% annual growth in follower base through Social Media Marketing and signature events each year. Fran has been invited by the EducationUSA Beijing Office as a keynote speaker to co-present the annual counselors' training workshops. In 2021, Fran was appointed co-chair of the Education Committee at the American Chamber of Commerce in China. \n\nBefore joining U of M, Fran worked in public affairs/government relations and marketing from local start-ups to U.S. Fortune 500s. Fran is a dynamic and innovative problem-solver who grew business revenue tremendously in her entrepreneurial experiences. \n\nFran holds a bachelor's degree in journalism from the University of Minnesota - Twin Cities and earned her master's degree in business from the University of Washington - Seattle, Foster School of Business. ",
      },

      {
        bgSrc: '../../../assets/img/about_people_bg_125.png',
        src: '../../../assets/img/about_people_125.png',
        src2: '../../../assets/img/new/25.png',
        name: 'Jessica Guo 郭璐宁',
        title: 'Director of College Counseling',
        des: 'Hangzhou Tianyuan College • TianBridge International',
        date: '2023 – 2025',
        experience: `2007-2008 Director of College Counseling, Cambridge A-level Center, Nanjing Foreign Language School
                        2008-2018 Director of College Counseling, Cambridge A-level Center, Hangzhou Foreign Language School
                        2018-2021 Director of Global Affairs and Guidance Counseling, Hangzhou Yungu School 
                        2021 to now Director of College Counseling, Hangzhou Tianyuan College • TianBridge International

                        Ms. GUO Luning, known as Jessica Guo, started to work as college counselor from 2007.  Successfully completed College Counseling certificate program with Collegeboard, Jessica is committed in facilitating students and parents in college counseling. She is also certified as the Career Advisor of IACA( International Association of Career Advisors), one of  top club coach in China and EtonX leadership teacher. As one of the earliest group of school-based college counselors in China, she set up three-year college counseling program, keeping on improving it through various perspectives, for example, through expanding the college counseling program to middle school students and parents, offering social-emotional program in school and building up parent school. Besides supportingn students through college application, she is keen on assisting them to look for, speak out and realize themselves through higher education and other opportunities. `,
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_09.png',
        src: '../../../assets/img/about_people_09.png',
        name: 'John Liu',
        title: 'Head of Career and University Guidance and Student Development',
        des: 'YCYW Schools',
        date: '2023 – 2025',
        experience:
          'John Liu is in his 20th year as an educator, with 14 years working in international schools. John is currently the Head of Pastoral Care for YCYW Schools China. His international school experience also includes serving as the Vice Principal of Wellness and Wellbeing at United World College Southeast Asia in Singapore for two years, serving as the Regional Coordinator for University Guidance for YCIS and YWIES schools in China for seven years, and the Director of College Counselling and Student Support in International Bilingual School in Hsinchu Science Park, Taiwan, for four years. John has an M.Ed in Private School Leadership, an M.A. in Educational Policy and Educational Leadership from Teachers College, Columbia University, and an M.A. in Secondary Social Studies Education from CUNY, Lehman. John has also received his certificate for international Principalship from the Principal Training Center.',
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_01.png',
        src: '../../../assets/img/about_people_01.png',
        name: 'Percy Jiang 蒋小波',
        title: 'Director of College Counseling',
        des: 'Keystone Academy',
        date: '2023 – 2025',
        experience: `2010-2016: College Counselor, Director of College Counseling, Beijing National Day School
            2013 – 2016: Government Relations Committee, OACAC
            2016 - Present: Director of College Counseling, Keystone Academy
            2017: Delegate, Executive Board of International ACAC`,
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_12.png',
        src: '../../../assets/img/new_people_01.png',
        name: 'Ruby Cheng, EdD 成妍洁',
        title: 'Assistant Director, Global Brown Center',
        des: 'Brown University',
        date: '2023 – 2025',
        experience:
          'Dr. Yanjie (Ruby) Cheng is the director of the international enrollment at the University of Colorado Colorado Springs. She holds a doctorate degree in Leadership for Educational Equity with a research agenda promotes education equity and diversity for international students and educators. Ruby is a dedicated advocate for international students with over ten years of professional experience. She served on the committees of the National Association of Foreign Students Advisors (NAFSA) and Association of International Education Administrators (AIEA). Currently she is on the International ACAC Diversity, Equity, and Inclusion committee. Ruby also has extensive experience in presenting at international conferences such as EducationUSA Forum, NAFSA, International Association of College Admissions and Counselling (International ACAC), ChinaICAC, and Association of International Education Administrators (AIEA). Ruby’s advocacy articles were published on the Inside Higher Ed and the Professionals International Education (PIE).  ',
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_111.png',
        src: '../../../assets/img/Ruru Huang.png',
        name: 'Ruru Huang 黄茹茹',
        title: 'University and Careers Counsellor',
        des: 'Dulwich College Shanghai Pudong',
        date: '2023 – 2025',
        experience:
          'Ruru Huang has been a dedicated University College Counselor (UCC) since 2010, beginning her journey while still a senior in college. With nearly a decade of experience in public high schools across Beijing, followed by four years at a bilingual school in Shenzhen, she is now in her second year at Dulwich College Shanghai Pudong. Her diverse background in some of the largest economic hubs in Mainland China has equipped her with a comprehensive understanding of the international education landscape and the varied needs of students. This experience has shaped her unique approach to helping students find their best fit and achieve long-term success.\n\nIn addition to her counseling work, Ruru actively contributes to the counseling community through various volunteer roles. She serves as the co-chair of the China ICAC RSL Committee, where she has led key initiatives such as the Leadership Institute and Speaker Series. As a mentor in both the ChinaICAC and International ACAC mentorship programs, she has been recognized as China ICAC’s Mentor of the Year for her dedication to supporting junior counselors and their peers. She was also the founding member of Great Bay Area College Counseling Connect and has contributed to organize 2 regional Connect events.\n\nOutside of her role as a UCC, Ruru is a member of the DEI committee for International ACAC and advocates for global citizenship and social justice. She is passionate about volunteering and making a positive impact in her community. This version aims to present Ruru’s qualifications and experiences in a more relatable manner while still highlighting her professional achievements and commitment to her field.',
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_04.png',
        src: '../../../assets/img/about_people_04.png',
        special: 1,
        name: 'Shawn Moore 莫灵风',
        title: 'Chief East Asia Representative',
        title2: 'Freelance Musician',
        des: 'Bard College',
        date: '2023 – 2025',
        experience:
          'Shawn is an experienced higher education professional, having worked for Bard College in Asia in a variety of capacities over the past 8 years, including recruitment, alumni engagement and development, and local partnership development. Shawn has experience building institutions in China; he negotiated and set up a partnership to create Bard’s first Early College program outside of the US, in Shenzhen, and is currently working on plans to build an arts center in Xiamen. Active in the education community, he is part of the founding team for ChinaICAC, the leading China based association for college admissions, and serves on its executive and membership committees. He is also a senior advisor for an edtech marketplace startup called Globiliti. Early after his move to China, he spent a brief period of time working in boutique brokerage firm in Beijing. In his spare time, Shawn is also a professional musician; he has recorded numerous albums, writes music, performs widely as a solo violinist and is a member of several Beijing based bands. He holds a B.A. and B.M. in Asian Studies and Music from Bard College, and a M.M. from Yale University, where he was also a recipient of the Light Fellowship for study in Korea. ',
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_05.png',
        src: '../../../assets/img/about_people_05.png',
        name: 'Shiny Wang 王实',
        title: 'Vice Principal',
        des: 'Beijing No.4 High School International Campus',
        date: '2023 – 2025',
        experience:
          "Wang, Shi (Shiny) is Vice Principal of Beijing No.4 High School International Campus. Member of NACAC & International ACAC, Member of the First International Advisory Committee of College Board, Secretary-General of Beijing Academy for College Counseling. He was one of China's first school-based counselors to pioneer college admission/ counseling for students. With more than 20 years of experience as teacher of English and over 15 years of counseling, he is widely recognized as China's expert in college counseling and international education globally. Furthermore, he has written articles on China's international education that were published in many public media including New York Times. Author of a best seller for guiding students for U.S application to colleges.",
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_110.png',
        src: '../../../assets/img/about_people_110.png',
        src2: '../../../assets/img/new/2.png',
        name: 'Sophia Hua 华夏',
        title: 'Director of College Counseling',
        des: 'Beijing National Day School',
        date: '2023 – 2025',
        experience:
          '2011-present, College Counselor, National Curriculum Coordinator, Teacher, Beijing National Day School \n\nMs. Xia HUA (Sophia) has been working with students seeking overseas college education since 2011, with an in-depth understanding of curriculum design across AP, IB, CAIE and Chinese National. Having deeply engaged in the front line of the national curriculum reform in China, she is able to draw from her teaching experience a refreshed appreciation of, as well as a firm belief in “unlimited possibilities” into her daily contact with students. She is Secretary General of Beijing Academy of College Counseling(BACC), where she maintains vibrant collaboration with peer high schools and higher education institutions to promote professional practices in the region and help with the professional development of counselors. She is an ardent advocate for kindness, honesty & originality, and particularly enjoys traveling.',
      },
      {
        src2: '../../../assets/img/new/22.png',
        bgSrc: '../../../assets/img/about_people_bg_122.png',
        src: '../../../assets/img/about_people_122.png',
        name: 'Teresa Li 李天虹',
        title:
          'General Manager & Director \n Growth, Client Experience & Marketing, \nGreater China',
        des: 'Cialfo',
        date: '2023 – 2025',
        experience: `Ms. Teresa Li holds a TESOL Master’s degree at Portland State University and is an highly experienced educator with 10 years of experience working in a variety of capacities in international schools and universities prior to joining Cialfo, including college counseling and admissions recruitment. She is currently the General Manager of Greater China at Cialfo, who has been striving to support Chinese high school students and counselors throughout the early career exploration and college search and selection process. Active in the education community, Teresa was also actively involved in International ICAC and NACAC and served on its membership committees. It is Teresa’s on-going passion to help students and counselors in China gain access to education opportunities globally to achieve their goals and dreams.`,
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_06.png',
        src: '../../../assets/img/about_people_06.png',
        name: 'Vivian Zhu 朱慎敏',
        title: 'Director of College Counseling Office',
        des: 'Chongqing BI Academy',
        date: '2023 – 2025',
        experience:
          '2008-2017：College Counselor, Director of College Counseling, Chongqing No. 1 International Studies School\n2018 - Present: College Counselor, Director of College Counseling, Chongqing BI Academy\nMs. Zhu Shenmin, known as Vivian Zhu, has embarked on the college counseling job for over 10 years. Since 2008, she fully engaged herself into school-based college counseling development in Southwest of China. Successfully completed College Counseling certificate program at University of California - Los Angeles, Vivian devoted herself to provide professional advice to assist her students with university applications, career navigations, and soft skills trainings. Meanwhile, she collaborated with international institutes to establish contacts with local schools. She is actively involved in International ACAC, Harvard Summer Institute on College Admissions, ChinaICAC, UCAS Conferences, and other college counselors seminars, studying and receiving new perspectives from professionals and sharing her experiences and ideas with other counselors from all over the world.',
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_102.png',
        src: '../../../assets/img/about_people_102.png',
        name: 'Xiaofeng Wan 万晓峰',
        title:
          'Associate Dean of Admission \nCoordinator of International Recruitment',
        des: 'Amherst College',
        date: '2023 – 2025',
        experience: `Since 2015, Xiaofeng has been leading the international recruitment efforts at Amherst College where he oversees all aspects of international admissions, including managing the College’s large number of international applications, recruiting on multiple continents, and chairing the international committee. He is also on the College’s domestic admissions team where he recruits domestically in the United States. Before joining Amherst, Xiaofeng was a member of the admissions office at the College of the Holy Cross, in Worcester, Massachusetts, where he initiated the institution’s admissions strategies in East Asia, recruited domestically in the US, and served on the admissions committee. 

            Xiaofeng is a frequent speaker at professional conferences, such as InternationalACAC, EducationUSA Forum, Council of International Schools, ChinaICAC, New England Association for College Admission Counseling, and Harvard China Education Symposium. He has published multiple op-eds on international student issues on Inside Higher Education, University World News and International Higher Education. He has been interviewed and quoted by a variety of media outlets, including the Wall Street Journal, Inside Higher Education, The Economist, CGTN America, China Daily, the 21st Century Business Herald, the Wire China, and so on. He’s the author of the Chinese translation of Admission Matters,  one of the most widely used college admission guidebooks in the United States.    
                                        
            Prior to coming to the United States in 2011, he was an English broadcast journalist at China Radio International in Beijing, reporting on domestic and international affairs. While working full-time at Amherst College, he is currently pursuing his doctorate in the Executive Ed.D. in Higher Education program at the Lynch School of Education and Human Development at Boston College.`,
      },
      {
        bgSrc: '../../../assets/img/about_people_666.png',
        src: '../../../assets/img/about_people_666.png',
        name: 'Zoe Chen 陈祎',
        title: 'Director',
        des: 'EAmaster',
        date: '2023 – 2025',
        experience: false,
      },
    ]
    this.leaderList3 = [
      {
        bgSrc: '../../../assets/img/about_people_detail_01.png',
        src: '../../../assets/img/about_people_01.png',
        src2: '../../../assets/img/new/29.png',
        aSrc: '../../../assets/img/round/pic_01.png',
        name: 'Percy Jiang 蒋小波',
        title: 'Director of College Counseling',
        des: 'Keystone Academy',
        date: '2023 – 2025',
        experience: `2010-2016: College Counselor, Director of College Counseling, Beijing National Day School
                2013 – 2016: Government Relations Committee, OACAC
                2016 - Present: Director of College Counseling, Keystone Academy
                2017: Delegate, Executive Board of International ACAC`,
      },
    ]
    this.peopleList3 = [
      {
        name: 'Ashley Sun 孙玥',
        title: 'College Counselor',
        des: 'Beijing National Day School',
        date: '2024 - 2026',
      },
      {
        name: 'Bo Liu 刘铂',
        title: 'Director of Marketing and Recruitment',
        des: 'Michigan State University',
        date: '2023 – 2025',
      },
      {
        name: 'Lydia Luo 罗旸',
        title: 'College Counselor',
        des: 'The Affiliated High School of Peking University',
        date: '2024 - 2026',
      },
      {
        name: 'Michelle Liang 梁珊',
        title: 'Secondary School College Counselor',
        des: 'Daystar Academy',
        date: '2024 - 2026',
      },
      {
        name: 'Paula Zhou 周娜',
        title: 'College Counselor',
        des: 'The Second High School Attached to Beijing Normal University',
        date: '2024 - 2026',
      },
      {
        name: 'Pingping Li 李苹苹',
        title: 'College Counselor',
        des: 'Guangzhou Huangpu Huawai Tongman Foreign Language School',
        date: '2024 - 2026',
      },
      {
        name: 'Sonja Song 宋李佳',
        title: 'College Counselor',
        des: 'Keystone Academy',
        date: '2023 – 2025',
      },
      {
        name: 'Teresa Tu 涂欣',
        title: 'College Counselor',
        des: 'Beijing National Day School',
        date: '2023 – 2025',
      },
      {
        name: 'Wendy Su 苏诚敏',
        title: 'College Counselor',
        des: 'Tsinglan School',
        date: '2024 - 2026',
      },
    ]
    this.leaderList4 = [
      {
        bgSrc: '../../../assets/img/about_people_detail_09.png',
        src: '../../../assets/img/about_people_09.png',
        aSrc: '../../../assets/img/round/pic_02.png',
        name: 'John Liu',
        title: 'Head of Career and University Guidance and Student Development',
        des: 'YCYW Schools',
        date: '2023 – 2025',
        experience:
          'John Liu is in his 20th year as an educator, with 14 years working in international schools. John is currently the Head of Pastoral Care for YCYW Schools China. His international school experience also includes serving as the Vice Principal of Wellness and Wellbeing at United World College Southeast Asia in Singapore for two years, serving as the Regional Coordinator for University Guidance for YCIS and YWIES schools in China for seven years, and the Director of College Counselling and Student Support in International Bilingual School in Hsinchu Science Park, Taiwan, for four years. John has an M.Ed in Private School Leadership, an M.A. in Educational Policy and Educational Leadership from Teachers College, Columbia University, and an M.A. in Secondary Social Studies Education from CUNY, Lehman. John has also received his certificate for international Principalship from the Principal Training Center.',
      },
    ]
    this.leaderListElection = [
      {
        name: 'Ciara Chen 陈皓华',
        title: 'College Counselor',
        des: 'HD Beijing School',
        date: '2024 - 2026',
      },
      {
        name: 'Jacky Shen 申盛',
        title: 'College Counselor',
        des: 'Jurong Country Garden School',
        date: '2024 - 2026',
      },
      {
        name: 'Pan Pan 潘攀',
        title: 'Counselor',
        des: 'Chiway Repton School Xiamen',
        date: '2024 - 2026',
      },
      {
        name: 'Veela Yang 杨天虹',
        title: 'Counselor',
        des: 'Shanghai United International School Wanyuan Campus',
        date: '2024 - 2026',
      },
      {
        name: 'Vivian Liu 刘微',
        title: 'College Counselor',
        des: 'Nord Anglia Chinese International School Shanghai',
        date: '2024 - 2026',
      },
    ]

    this.peopleList4 = [
      {
        bgSrc: '../../../assets/img/about_people_detail_05.png',
        src: '../../../assets/img/about_people_05.png',
        src2: '../../../assets/img/new/6.png',
        name: 'Shiny Wang 王实',
        title: 'Vice Principal',
        des: 'Beijing No.4 High School International Campus',
        date: '2021 – 2022',
        experience:
          "Wang, Shi (Shiny) is Vice Principal of Beijing No.4 High School International Campus. Member of NACAC & International ACAC, Member of the First International Advisory Committee of College Board, Secretary-General of Beijing Academy for College Counseling. He was one of China's first school-based counselors to pioneer college admission/ counseling for students. With more than 20 years of experience as teacher of English and over 15 years of counseling, he is widely recognized as China's expert in college counseling and international education globally. Furthermore, he has written articles on China's international education that were published in many public media including New York Times. Author of a best seller for guiding students for U.S application to colleges.",
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_108.png',
        src: '../../../assets/img/about_people_108.png',
        src2: '../../../assets/img/new/7.png',
        name: 'Fran Liu 刘芳远',
        title: 'Director, China Office',
        des: 'University of Minnesota',
        date: '2022 – 2023',
        experience:
          "Fran Liu joined the University of Minnesota (U of M) China Office in 2019. Her work focuses on advancing the University brand systemwide by sharing U of M information with prospective students and families, engaging the Chinese alumni communities, and developing educational collaborations between the University and its partners in China. \n\nAs the University representative office in China, Fran and her team have achieved a 15% annual growth in follower base through Social Media Marketing and signature events each year. Fran has been invited by the EducationUSA Beijing Office as a keynote speaker to co-present the annual counselors' training workshops. In 2021, Fran was appointed co-chair of the Education Committee at the American Chamber of Commerce in China. \n\nBefore joining U of M, Fran worked in public affairs/government relations and marketing from local start-ups to U.S. Fortune 500s. Fran is a dynamic and innovative problem-solver who grew business revenue tremendously in her entrepreneurial experiences. \n\nFran holds a bachelor's degree in journalism from the University of Minnesota - Twin Cities and earned her master's degree in business from the University of Washington - Seattle, Foster School of Business. ",
      },
    ]
    this.leaderList5 = [
      {
        bgSrc: '../../../assets/img/about_people_detail_110.png',
        src: '../../../assets/img/about_people_110.png',
        src2: '../../../assets/img/new/2.png',
        aSrc: '../../../assets/img/round/pic_03.png',
        name: 'Sophia Hua 华夏',
        title: 'Director of College Counseling',
        des: 'Beijing National Day School',
        date: '2023 – 2025',
        experience:
          '2011-present, College Counselor, National Curriculum Coordinator, Teacher, Beijing National Day School \n\nMs. Xia HUA (Sophia) has been working with students seeking overseas college education since 2011, with an in-depth understanding of curriculum design across AP, IB, CAIE and Chinese National. Having deeply engaged in the front line of the national curriculum reform in China, she is able to draw from her teaching experience a refreshed appreciation of, as well as a firm belief in “unlimited possibilities” into her daily contact with students. She is Secretary General of Beijing Academy of College Counseling(BACC), where she maintains vibrant collaboration with peer high schools and higher education institutions to promote professional practices in the region and help with the professional development of counselors. She is an ardent advocate for kindness, honesty & originality, and particularly enjoys traveling.',
      },
    ]
    this.peopleList5 = [
      {
        name: 'Abbott Zhang 张航天',
        title: 'Regional College Counseling Head',
        des: 'Beijing International Bilingual Academy',
        date: '2024 - 2026',
      },
      {
        name: 'Amanda Yan 闫晓辉',
        title: 'Regional Deputy Education Director',
        des: 'Nord Anglia China Bilingual Schools',
        date: '2023 – 2025',
      },
      {
        name: 'Coco Feng 冯可可',
        title: 'College Counselor',
        des: 'Tsinglan School',
        date: '2024 – 2026',
      },
      {
        name: 'Coco Kou 寇缤元',
        title: 'Career and University Guidance Counselor',
        des: 'Yew Chung International School of Shanghai, Puxi',
        date: '2024 – 2026',
      },
      {
        name: 'Echo Jin 金婉',
        title: 'College Counselor',
        des: 'Hangzhou Yungu School',
        date: '2024 - 2026',
      },
      {
        name: 'Goldie Guo 郭丹',
        title: 'College Counselor',
        des: 'Xi’an Tie Yi High School',
        date: '2023 – 2025',
      },
      {
        name: 'Jasmine Gao 高莘文',
        title: 'College Counselor',
        des: 'Hangzhou Tianyun College',
        date: '2024 – 2026',
      },
      {
        name: 'Joyce Yu 于思超',
        title: 'International officer, Shanghai Office',
        des: 'University of Glasgow',
        date: '2023 – 2025',
      },
      {
        name: 'Liz Liu 刘晓',
        title: 'Dean of School Counselor',
        des: 'Sino-Canada Concord School of Hefei High Tech Zone',
        date: '2023 – 2025',
      },
      {
        name: 'Patty Yang 杨玉婷',
        title: 'Counselor',
        des: 'The Affiliated High School of Peking University',
        date: '2024 - 2026',
      },
      {
        name: 'Paul Zhai 翟羽',
        title: 'Growth Partnership Manager',
        des: 'Cialfo',
        date: '2023 – 2025',
      },
      {
        name: 'Ray Wu 吴瑞丰',
        title: 'Regional Manager, East Asia',
        des: 'Huron at Western University',
        date: '2023 – 2025',
      },
    ]

    this.leaderList6 = [
      {
        bgSrc: '../../../assets/img/about_people_666.png',
        src: '../../../assets/img/about_people_666.png',
        aSrc: '../../../assets/img/round/pic_04.png',
        name: 'Zoe Chen 陈祎',
        title: 'Director',
        des: 'EAmaster',
        date: '2023 – 2025',
        experience: false,
      },
    ]

    this.leaderList7 = [
      {
        bgSrc: '../../../assets/img/about_people_detail_108.png',
        src: '../../../assets/img/about_people_108.png',
        aSrc: '../../../assets/img/round/pic_021.png',
        name: 'Fran Liu 刘芳远',
        title: 'Director, China Office',
        des: 'University of Minnesota',
        date: '2023 – 2025',
        experience:
          "Fran Liu joined the University of Minnesota (U of M) China Office in 2019. Her work focuses on advancing the University brand systemwide by sharing U of M information with prospective students and families, engaging the Chinese alumni communities, and developing educational collaborations between the University and its partners in China. \n\nAs the University representative office in China, Fran and her team have achieved a 15% annual growth in follower base through Social Media Marketing and signature events each year. Fran has been invited by the EducationUSA Beijing Office as a keynote speaker to co-present the annual counselors' training workshops. In 2021, Fran was appointed co-chair of the Education Committee at the American Chamber of Commerce in China. \n\nBefore joining U of M, Fran worked in public affairs/government relations and marketing from local start-ups to U.S. Fortune 500s. Fran is a dynamic and innovative problem-solver who grew business revenue tremendously in her entrepreneurial experiences. \n\nFran holds a bachelor's degree in journalism from the University of Minnesota - Twin Cities and earned her master's degree in business from the University of Washington - Seattle, Foster School of Business. ",
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_05.png',
        src: '../../../assets/img/about_people_05.png',
        aSrc: '../../../assets/img/round/pic_05.png',
        name: 'Shiny Wang 王实',
        title: 'Vice Principal',
        des: 'Beijing No.4 High School International Campus',
        date: '2023 – 2025',
        experience:
          "Wang, Shi (Shiny) is Vice Principal of Beijing No.4 High School International Campus. Member of NACAC & International ACAC, Member of the First International Advisory Committee of College Board, Secretary-General of Beijing Academy for College Counseling. He was one of China's first school-based counselors to pioneer college admission/ counseling for students. With more than 20 years of experience as teacher of English and over 15 years of counseling, he is widely recognized as China's expert in college counseling and international education globally. Furthermore, he has written articles on China's international education that were published in many public media including New York Times. Author of a best seller for guiding students for U.S application to colleges.",
      },
    ]
    this.peopleList7 = [
      {
        name: 'Ria Ye 叶莹莹',
        title: 'Vice Director of College Counseling',
        des: 'Ningbo Foreign Language School',
        date: '2023 – 2025',
      },
      {
        name: 'Yinglun Tang 汤英伦',
        title: 'China Representative',
        des: 'University of York',
        date: '2024 - 2026',
      },
    ]

    this.leaderList8 = [
      {
        src2: '../../../assets/img/new/22.png',
        bgSrc: '../../../assets/img/about_people_bg_122.png',
        src: '../../../assets/img/about_people_122.png',
        aSrc: '../../../assets/img/round/pic_07.png',
        name: 'Teresa Li 李天虹',
        title:
          'General Manager & Director Growth,\n Client Experience & Marketing,\n Greater China',
        des: 'Cialfo',
        date: '2023 – 2025',
        experience: `Ms. Teresa Li holds a TESOL Master’s degree at Portland State University and is an highly experienced educator with 10 years of experience working in a variety of capacities in international schools and universities prior to joining Cialfo, including college counseling and admissions recruitment. She is currently the General Manager of Greater China at Cialfo, who has been striving to support Chinese high school students and counselors throughout the early career exploration and college search and selection process. Active in the education community, Teresa was also actively involved in International ICAC and NACAC and served on its membership committees. It is Teresa’s on-going passion to help students and counselors in China gain access to education opportunities globally to achieve their goals and dreams.`,
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_06.png',
        src: '../../../assets/img/about_people_06.png',
        aSrc: '../../../assets/img/round/pic_06.png',
        name: 'Vivian Zhu 朱慎敏',
        title: 'Director of College Counseling Office',
        des: 'Chongqing BI Academy',
        date: '2023 – 2025',
        experience:
          '2008-2017：College Counselor, Director of College Counseling, Chongqing No. 1 International Studies School\n2018 - Present: College Counselor, Director of College Counseling, Chongqing BI Academy\nMs. Zhu Shenmin, known as Vivian Zhu, has embarked on the college counseling job for over 10 years. Since 2008, she fully engaged herself into school-based college counseling development in Southwest of China. Successfully completed College Counseling certificate program at University of California - Los Angeles, Vivian devoted herself to provide professional advice to assist her students with university applications, career navigations, and soft skills trainings. Meanwhile, she collaborated with international institutes to establish contacts with local schools. She is actively involved in International ACAC, Harvard Summer Institute on College Admissions, ChinaICAC, UCAS Conferences, and other college counselors seminars, studying and receiving new perspectives from professionals and sharing her experiences and ideas with other counselors from all over the world.',
      },
    ]
    this.peopleList8 = [
      {
        bgSrc: '../../../assets/img/about_people_detail_12.png',
        src: '../../../assets/img/about_people_12.png',
        src2: '../../../assets/img/new/12.png',
        name: 'Frances Zhang 张楠',
        title:
          'Assistant to President \n Dean of College Counseling & Financial Aid',
        des: 'WLSA Shanghai Academy',
        date: '2023 – 2025',
        experience:
          'Nan (Frances) served on various Committees of International ACAC. She did some education sessions and the first Chinese webinar at International ACAC, NACAC, over the past years. She was faculty for Pre-conference and College Board Summer Institute in NYU Shanghai over the past two years. Being a diligent learner, she attended conferences at home and abroad, and many college fly-in tours, so that she could share what she learnt with the community. Having worked at SHSID for 10 years, she gained experience of assisting international students to apply to colleges worldwide. She also worked for AdvancED Accreditation Engagement Review team and Shanghai Institute for International Curriculum Research to inspect international programs in schools. Her active engagement in the international community enabled her to introduce more resources to colleagues in the area and build a better regional collaborative network. She now started her new journey at WLSA Shanghai Academy to support more Chinese students. Before her work at SHSID, she was selected to be the only Chinese intern at the Department for Business, Innovation & Skills – GOV.UK in London. Sticking to the principle of “choose what you like, and like what you choose”, she seeks to guide students to find the best fit institutions and making our professional exchange environment more inclusive.',
      },
      {
        name: 'Joshua Ding 丁亮',
        title: 'Director of College Counseling Office',
        des: 'Wuhan Haidian Foreign Language Shiyan School',
        date: '2024 - 2026',
      },
    ]

    this.leaderList9 = [
      {
        bgSrc: '../../../assets/img/about_people_detail_10.png',
        src: '../../../assets/img/about_people_10.png',
        aSrc: '../../../assets/img/round/pic_08.png',
        name: 'Francis Miller 陈泽汉',
        title: 'Director of College Counseling',
        des: "Xi'an Tie Yi High School",
        date: '2023 – 2025',
        experience:
          'Francis Miller is a director of college counseling at Xi’an Tie Yi High School in Shaanxi Province, China, since 2018. He holds membership with International ACAC and ChinaICAC, where he volunteers on the membership committees for both organizations. He also writes articles for the Cialfo Community as a Counselor in Residence. Since moving to Xi’an, he has served as a Citizen Liaison Volunteer in Xi’an for the U.S. Embassy in Beijing. \n\nHe studied Chinese language at Tsinghua University as a Foreign Language Area Studies fellow supported by the U.S. Department of Education. He received his B.A. and M.A. from the University of Pennsylvania. He is an avid bicyclist and restaurant reviewer for the English magazine Xianease.',
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_04.png',
        src: '../../../assets/img/about_people_04.png',
        aSrc: '../../../assets/img/round/pic_09.png',
        special: 1,
        name: 'Shawn Moore 莫灵风',
        title: 'Chief East Asia Representative',
        title2: 'Freelance Musician',
        des: 'Bard College',
        date: '2023 – 2025',
        experience:
          'Shawn is an experienced higher education professional, having worked for Bard College in Asia in a variety of capacities over the past 8 years, including recruitment, alumni engagement and development, and local partnership development. Shawn has experience building institutions in China; he negotiated and set up a partnership to create Bard’s first Early College program outside of the US, in Shenzhen, and is currently working on plans to build an arts center in Xiamen. Active in the education community, he is part of the founding team for ChinaICAC, the leading China based association for college admissions, and serves on its executive and membership committees. He is also a senior advisor for an edtech marketplace startup called Globiliti. Early after his move to China, he spent a brief period of time working in boutique brokerage firm in Beijing. In his spare time, Shawn is also a professional musician; he has recorded numerous albums, writes music, performs widely as a solo violinist and is a member of several Beijing based bands. He holds a B.A. and B.M. in Asian Studies and Music from Bard College, and a M.M. from Yale University, where he was also a recipient of the Light Fellowship for study in Korea. ',
      },
    ]
    this.peopleList9 = [
      {
        name: 'Julia Ju 鞠晖',
        title: 'University & Careers Counselling Coordinator',
        des: 'Dulwich College Shanghai Pudong',
        date: '2023 – 2025',
        experience: false,
      },
      {
        name: 'Melissa Meltzer Warehall 梅丽莎',
        title: 'Head of College Counselling',
        des: 'Daystar Academy',
        date: '2023 – 2025',
        experience: false,
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_101.png',
        src: '../../../assets/img/about_people_101.png',
        src2: '../../../assets/img/new/10.png',
        name: 'Ming Rong Weng 翁明容',
        title: 'University and Career Advisor',
        des: 'International School of Beijing',
        date: '2023 – 2025',
        experience:
          'Ming was born in Fujian, China and moved to the United States at the age of 8. She received her Bachelor’s Degree from Yale University in East Asian Studies and a Master’s Degree in Global Studies in Education from University of Illinois Urbana-Champaign. With more than eight years of experience in university admission and counseling, she has guided students to destinations worldwide, including the United States, Canada, Australia, United Kingdom, China, Korea, Japan, Hong Kong, and Singapore. As a college counselor, she loves working with students to identify their interests and passions and guiding them to pursue their academic goals. She strongly believes in the concept of best fit and works with students to enhance and best highlight their strengths on their college applications worldwide.  Ming is bilingual in English and Mandarin.  When she is not in her office, you can always find her hunting for a good bite to eat, hitting the gym, or stretching on a yoga mat.',
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_107.png',
        src: '../../../assets/img/about_people_107.png',
        src2: '../../../assets/img/new/11.png',
        name: 'Phoebe Zuo 左萍',
        title: 'Head Counselor',
        des: 'Xi’an Tie Yi High School',
        date: '2023 – 2025',
        experience:
          'Member of IACAC \nMore than 10 years of experience in college counseling. \nHead counselor of Xian Tie Yi High School; \nFamiliar with AP and A-Level courses system and application features. \nWorked with the Xian Tie Yi High School Counseling team to establish a professional counseling system and standards for my high school. \nOrganized and hosted many regional college counseling workshops. \nDedicated to the development of Northwest college guidance team cooperation and promotion. \nCommitted to contributing to the development of international education together with all the members of ChinaICAC, and to bridging the gap between Chinese and Western education. ',
      },
      {
        name: 'Wei Huo (Lisa) 霍炜',
        title: 'Associate Director of Student Future Readiness',
        des: 'Hangzhou Yungu School',
        date: '2023 – 2025',
        experience: false,
      },
      {},
    ]
    this.leaderList10 = [
      {
        bgSrc: '../../../assets/img/about_people_bg_126.png',
        src: '../../../assets/img/about_people_126.png',
        src2: '../../../assets/img/new/26.png',
        aSrc: '../../../assets/img/round/pic_010.png',
        name: 'Amy Zou 邹培',
        title: 'Coordinator of College Counseling，\nAP Coordinator',
        des: 'Tsinghua International School ',
        date: '2023 – 2025',
        experience: `Has been working at Tsinghua International School since 2010 and is now serving as the Coordinator of College Counseling and the AP Coordinator. Over the past 12 years, Amy has guided students from different cultural backgrounds to universities worldwide, not only as a college counselor but as a lifelong learner, seeking opportunities to learn more about career advising and mental health counseling strategies and skills. She achieved the Certificate of College Counseling at UCLA extension in 2017, the Career Advisor Certificate from the International Association of Career Advisors in 2019, and is working on a social psychology program at Tsinghua University. `,
      },
      {
        bgSrc: '../../../assets/img/about_people_bg_125.png',
        src: '../../../assets/img/about_people_125.png',
        src2: '../../../assets/img/new/25.png',
        aSrc: '../../../assets/img/round/pic_011.png',
        name: 'Jessica Guo 郭璐宁',
        title: 'Director of College Counseling',
        des: 'Hangzhou Tianyuan College • TianBridge International',
        date: '2023 – 2025',
        experience: `2007-2008 Director of College Counseling, Cambridge A-level Center, Nanjing Foreign Language School
                        2008-2018 Director of College Counseling, Cambridge A-level Center, Hangzhou Foreign Language School
                        2018-2021 Director of Global Affairs and Guidance Counseling, Hangzhou Yungu School 
                        2021 to now Director of College Counseling, Hangzhou Tianyuan College • TianBridge International

                        Ms. GUO Luning, known as Jessica Guo, started to work as college counselor from 2007.  Successfully completed College Counseling certificate program with Collegeboard, Jessica is committed in facilitating students and parents in college counseling. She is also certified as the Career Advisor of IACA( International Association of Career Advisors), one of  top club coach in China and EtonX leadership teacher. As one of the earliest group of school-based college counselors in China, she set up three-year college counseling program, keeping on improving it through various perspectives, for example, through expanding the college counseling program to middle school students and parents, offering social-emotional program in school and building up parent school. Besides supportingn students through college application, she is keen on assisting them to look for, speak out and realize themselves through higher education and other opportunities. `,
      },
    ]
    this.peopleList10 = [
      {
        name: 'Cissy Zhong 钟希',
        title: 'Vice Director of College Counseling',
        des: 'Chengdu Shude High School International Department',
        date: '2024 – 2026',
        experience: false,
      },
      {
        name: 'Eilin Liu 刘爱莲',
        title: 'Future Student Officer',
        des: 'The University of Sydney',
        date: '2023 – 2025',
        experience: false,
      },
      //   {
      //     name: 'Emma Liu 刘佳',
      //     title: 'Deputy Director of AP Program',
      //     des: 'Guangzhou Foreign Language School',
      //     date: '2023 – 2025',
      //     experience: false,
      //   },
      {
        bgSrc: '../../../assets/img/about_people_detail_104.png',
        src: '../../../assets/img/about_people_104.png',
        src2: '../../../assets/img/new/15.png',
        name: 'Gaby Dong 董晓阳',
        title: 'Director of College Counseling \n Assistant to the Executive Principal',
        des: 'Beijing Changping Jialian School',
        date: '2023 – 2025',
        experience:
          'Gaby has 10 years of working experience as a college counselor, and 5 years as the director at The Affiliated High School of Peking University. Lots of leadership experience of guiding students through college applications, organizing events, collaborating with different departments, supporting school administration, etc. \nShe is also experienced in building college counseling systems and teams, as well as train and work with counselors from different campuses and help them build and manage the counseling office. \nGaby is passionate about promoting, sharing college counseling knowledge to others and fostering the relations between China and the world. She also would like to help to build and strengthen the counselors’ career development by creating more opportunities for each other.',
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_103.png',
        src: '../../../assets/img/about_people_103.png',
        src2: '../../../assets/img/new/16.png',
        name: 'Gillian Lian 练佳艳',
        title: 'G11-G12 College Counselor',
        des: 'Shanghai SMIC Private School International Division',
        date: '2023 – 2025',
        experience:
          "Gillian has been working in the International Education Industry for 10 years, once worked as a school counselor for both \n international school in China and public schools of Baltimore City School District. Taking the best use of school counseling mindset and skillsets, Gillian assisted over 300 students in getting accepted by best-fit universities and continuing to success in college life. \n Gillian graduated from the Johns Hopkins University with the Master's in School and Clinical Mental Health Counseling \nCredentials & Memberships\n· NBCC National Certified School Counselor\n· Maryland Certified School Counselor\n· CCE Career Facilitator \n· NACAC Member\n· ChinaICAC Commitee Member ",
      },
      {
        name: 'Irene Xu 徐颖',
        title: 'College Counselor',
        des: 'Suzhou North America High School',
        date: '2023 – 2025',
        experience: false,
      },
      {
        name: 'Joseph Xu 徐烨',
        title: 'College Counselor',
        des: 'HD Qingdao School',
        date: '2024 – 2026',
        experience: false,
      },
      {
        name: 'Lu Li 李璐',
        title: 'Career and University Guidance Counselor',
        des: 'Shanghai United International School Wanyuan Campus',
        date: '2024 – 2026',
        experience: false,
      },
    ]
    // Research, Scholarship and Learning Committee
    this.leaderList11 = [
      {
        bgSrc: '../../../assets/img/about_people_detail_12.png',
        src: '../../../assets/img/new_people_01.png',
        aSrc: '../../../assets/img/round/pic_012.png',
        name: 'Ruby Cheng, EdD 成妍洁',
        title: 'Assistant Director, Global Brown Center',
        des: 'Brown University',
        date: '2023 – 2025',
        experience:
          'Dr. Yanjie (Ruby) Cheng is the director of the international enrollment at the University of Colorado Colorado Springs. She holds a doctorate degree in Leadership for Educational Equity with a research agenda promotes education equity and diversity for international students and educators. Ruby is a dedicated advocate for international students with over ten years of professional experience. She served on the committees of the National Association of Foreign Students Advisors (NAFSA) and Association of International Education Administrators (AIEA). Currently she is on the International ACAC Diversity, Equity, and Inclusion committee. Ruby also has extensive experience in presenting at international conferences such as EducationUSA Forum, NAFSA, International Association of College Admissions and Counselling (International ACAC), ChinaICAC, and Association of International Education Administrators (AIEA). Ruby’s advocacy articles were published on the Inside Higher Ed and the Professionals International Education (PIE).  ',
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_111.png',
        src: '../../../assets/img/Ruru Huang.png',
        aSrc: '../../../assets/img/round/pic_026.png',
        name: 'Ruru Huang 黄茹茹',
        title: 'University and Careers Counsellor',
        des: 'Dulwich College Shanghai Pudong',
        date: '2023 – 2025',
        experience:
          'Ruru Huang has been a dedicated University College Counselor (UCC) since 2010, beginning her journey while still a senior in college. With nearly a decade of experience in public high schools across Beijing, followed by four years at a bilingual school in Shenzhen, she is now in her second year at Dulwich College Shanghai Pudong. Her diverse background in some of the largest economic hubs in Mainland China has equipped her with a comprehensive understanding of the international education landscape and the varied needs of students. This experience has shaped her unique approach to helping students find their best fit and achieve long-term success.\n\nIn addition to her counseling work, Ruru actively contributes to the counseling community through various volunteer roles. She serves as the co-chair of the China ICAC RSL Committee, where she has led key initiatives such as the Leadership Institute and Speaker Series. As a mentor in both the ChinaICAC and International ACAC mentorship programs, she has been recognized as China ICAC’s Mentor of the Year for her dedication to supporting junior counselors and their peers. She was also the founding member of Great Bay Area College Counseling Connect and has contributed to organize 2 regional Connect events.\n\nOutside of her role as a UCC, Ruru is a member of the DEI committee for International ACAC and advocates for global citizenship and social justice. She is passionate about volunteering and making a positive impact in her community. This version aims to present Ruru’s qualifications and experiences in a more relatable manner while still highlighting her professional achievements and commitment to her field.',
      },
    ]
    this.peopleList11 = [
      {
        name: 'Anny Wu 邬嘉雯',
        title: 'College Counselor',
        des: 'Vanke School, Pudong',
        date: '2023 – 2025',
      },
      {
        name: 'Carrie Sun 孙楚',
        title: 'College Counselor',
        des: 'Dalian American International School',
        date: '2023 – 2025',
      },
      {
        name: 'Ella Hu 胡学梅',
        title: 'College Counselor',
        des: 'Suzhou North America High School',
        date: '2023 – 2025',
      },
      {
        name: 'Emilie Liu 刘华胤',
        title: 'China Chief Representative',
        des: 'Sciences Po',
        date: '2023 – 2025',
      },
      {
        name: 'Emma Wang 王文怡',
        title: 'College Counselor',
        des: 'Shanghai DTD Academy',
        date: '2023 – 2025',
      },
      {
        name: 'Esther Zhao 赵彬芝',
        title: 'International Admissions Specialist',
        des: 'Baylor University',
        date: '2023 – 2025',
      },
      {
        name: 'Jeffrey Harmon 郝捷飞',
        title: 'College Counselor',
        des: 'Qingdao Academy',
        date: '2023 – 2025',
      },
      {
        name: 'Tie Sun 孙铁',
        title: 'Senior Assistant Director of Admission',
        des: 'Rhodes College',
        date: '2024 – 2026',
      },
      {
        name: 'Vanessa Lyu 吕成',
        title: 'Deputy Head of College Counseling Office',
        des: 'Jinan Xinhang Experimental Foreign Language School',
        date: '2023 – 2025',
      },
      {
        name: 'Vivian Lin 林薇',
        title: 'Assistant Director of Admissions',
        des: 'University of St Andrews',
        date: '2023 – 2025',
      },
    ]
    this.leaderList12 = [
      {
        bgSrc: '../../../assets/img/about_people_detail_102.png',
        src: '../../../assets/img/about_people_102.png',
        aSrc: '../../../assets/img/round/pic_013.png',
        name: 'Xiaofeng Wan 万晓峰',
        title:
          'Associate Dean of Admission \nCoordinator of International Recruitment',
        des: 'Amherst College',
        date: '2023 – 2025',
        experience: `Since 2015, Xiaofeng has been leading the international recruitment efforts at Amherst College where he oversees all aspects of international admissions, including managing the College’s large number of international applications, recruiting on multiple continents, and chairing the international committee. He is also on the College’s domestic admissions team where he recruits domestically in the United States. Before joining Amherst, Xiaofeng was a member of the admissions office at the College of the Holy Cross, in Worcester, Massachusetts, where he initiated the institution’s admissions strategies in East Asia, recruited domestically in the US, and served on the admissions committee. 

            Xiaofeng is a frequent speaker at professional conferences, such as InternationalACAC, EducationUSA Forum, Council of International Schools, ChinaICAC, New England Association for College Admission Counseling, and Harvard China Education Symposium. He has published multiple op-eds on international student issues on Inside Higher Education, University World News and International Higher Education. He has been interviewed and quoted by a variety of media outlets, including the Wall Street Journal, Inside Higher Education, The Economist, CGTN America, China Daily, the 21st Century Business Herald, the Wire China, and so on. He’s the author of the Chinese translation of Admission Matters,  one of the most widely used college admission guidebooks in the United States.    
                                        
            Prior to coming to the United States in 2011, he was an English broadcast journalist at China Radio International in Beijing, reporting on domestic and international affairs. While working full-time at Amherst College, he is currently pursuing his doctorate in the Executive Ed.D. in Higher Education program at the Lynch School of Education and Human Development at Boston College.`,
      },
    ]
    this.peopleList12 = [
      {
        // src: '../../../assets/img/round/about_people_131.png',
        src: '../../../assets/img/round/pic_014.png',
        name: 'Aidan B. Crowley',
        title: 'University Counselor',
        des: "St. Joseph's Institution International",
        date: '2023 – 2025',
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_106.png',
        // src: '../../../assets/img/about_people_106.png',
        src: '../../../assets/img/round/pic_015.png',
        src2: '../../../assets/img/new/17.png',
        name: 'Bruce Hammond',
        title: 'Vice Principal',
        des: 'Tsinglan School',
        date: '2023 – 2025',
        experience:
          'Bruce has been a teacher, administrator, and college counselor for nearly 30 years. He previously served as Deputy Director of the Kunming No. 1 High School International Center and Vice Principal/Director of College Counseling at Tsinghua International School. He has also been Director of College Counseling at Lake Ridge Academy (Ohio, USA), Sandia Preparatory School (New Mexico, USA), and High School Affiliated to Nanjing Normal University. He first came to China in 2008. Prior to his career in schools, Bruce served as managing editor of the Fiske Guide to Colleges, and he is co-author of four volumes in the Fiske series. In 2012, he initiated Tsinghua’s “East Meets West” conference. Bruce received a B.A. from Yale University and an M.A.T. from Brown University.',
      },
      {
        src: '../../../assets/img/round/pic_020.png',
        name: 'Frank Yuan 袁拔',
        title: 'General Manager',
        des: 'Kingold Education Division',
        date: '2023 – 2025',
        experience: false,
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_109.png',
        // src: '../../../assets/img/about_people_109.png',
        src: '../../../assets/img/round/pic_016.png',
        src2: '../../../assets/img/new/18.png',
        name: 'Hamilton Gregg',
        title: 'University and Career Guidance Counselor',
        des: 'Harrow Beijing',
        date: '2023 – 2025',
        experience:
          'Hamilton has been a college counselor in a school setting for over 23 years. In addition, he has been an independent consultant for the last 8 years. Hamilton is a member of International ACAC, NACAC, IECA. CIS. He is also a Certified Educational Planner (CEP). Hamilton is a past president of International ACAC and currently sit on the NACAC International Initiatives Committee.',
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_105.png',
        // src: '../../../assets/img/about_people_105.png',
        src: '../../../assets/img/round/pic_017.png',
        src2: '../../../assets/img/new/19.png',
        name: 'Isthier Chaudhury 乔峰',
        title: 'Director of Admissions',
        des: 'Swarthmore College',
        date: '2023 – 2025',
        experience:
          'Isthier has been an Admissions Counselor at the University of Rochester since 2013. He has been recruiting across China for his entire time at Rochester, along with other territories in Asia and Europe. His history with China goes back even farther, having studied abroad in Beijing for a year in 2009-2010, and then doing research in Shanghai during the summer of 2012. He is fluent in Chinese and makes it a point to diversify the provinces, cities, and schools that he reaches every time he returns to China. His goal is to provide opportunities for students beyond Beijing and Shanghai to get information about the college process, and help other universities understand how to effectively travel around and recruit in China.',
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_03.png',
        // src: '../../../assets/img/about_people_03.png',
        src: '../../../assets/img/round/pic_018.png',
        name: 'Rafael Katz 关世宁',
        title: 'Independent Counselor',
        des: '',
        date: '2023 – 2025',
        experience:
          'Mr. Katz has been a high school college counselor for over 20 years and a high school and middle teacher for many years prior to that. It is Mr. Katz ’s passion for education and helping students achieve their goals, as well as his interest in Chinese culture, that brings him to china. Before coming to Qibao Dwight, Mr. Katz worked for four years as the college counselor at SCIS Hongqiao.Prior to that he worked as a teacher and counselor in Portland, Oregon for seventeen years. Through the years Mr. Katz has had various educational experiences and opportunities including writing the Arco test guide for AP Government, being one of the founding teachers for Princeton Review test prep, and being a test supervisor in Shanghai for SAT, ACT, AP, and PSAT. Rafael is also a UCLA admissions reader. Rafael has a MS degree in school counseling from Portland State University, a MA in Asian Studies from Yale, and a BA in History and Chinese from Brown University. Rafael has a particular interest in art and spends much of his free time painting.',
      },
      {
        bgSrc: '../../../assets/img/about_people_detail_100.png',
        // src: '../../../assets/img/about_people_100.png',
        src: '../../../assets/img/round/pic_019.png',
        src2: '../../../assets/img/new/14.png',
        name: 'Robbie Shields 史儒宝',
        title: 'American Principal',
        des: 'Shanghai Qibao Dwight High School',
        date: '2023 – 2025',
        experience:
          'I am currently the American Principal at Shanghai Qibao Dwight, where I oversee our College Counseling, Curriculum, and International Faculty. Prior to this, I served as the International Director of College Counseling at Qibao Dwight, as well as an IB Business Management and Theory of Knowledge teacher. Prior to working in secondary education, I worked in higher education. From 2012-2018, I worked at Johns Hopkins University School of Advanced International Studies (SAIS) where I was based in Nanjing as the first Career Services Manager at the Hopkins-Nanjing Center. Prior to that, I worked at the University of Florida’s Warrington College of Business as an Academic Advisor & Career Coach, and the University of Tennessee’s Haslam School of Business as an Academic Advisor and Instructor. I have a Juris Doctorate in Law from the University of Florida. ',
      },
    ]
    this.currentName = 'Overview'
    this.top = 21
  }

  //初始化;
  ngOnInit() {
    const search = location.hash.split('/')[2]
    setTimeout(() => {
      this.touchTab(search)
    }, 100)
    // this.about(search, true);
    // window.addEventListener('scroll', this.Scroll)
    // console.log(this.setbar)
    this.fun = () => {
      let scrollTop =
        document.body.scrollTop || document.documentElement.scrollTop
      let obj = {
        Overview: 36,
        OrganizationalStructure: 80,
        // 'Committees': 90,
        Subcommittees: 124,
        VolunteerForChinaICAC: 168,
        ContactUs: 212,
      }
      // console.log(scrollTop);

      if (scrollTop < 833) {
        this.currentName = 'Overview'
        this.top = obj[this.currentName]
      } else if (scrollTop < 2456) {
        this.currentName = 'OrganizationalStructure'
        this.top = obj[this.currentName]
      } else if (scrollTop < 7935) {
        this.currentName = 'Subcommittees'
        this.top = obj[this.currentName]
      } else if (scrollTop < 8364) {
        this.currentName = 'VolunteerForChinaICAC'
        this.top = obj[this.currentName]
      } else {
        this.currentName = 'ContactUs'
        this.top = obj[this.currentName]
      }
    }
    window.addEventListener('scroll', this.fun)
    // setTimeout(() => {
    //     $('.wrap-box').css("min-height", $(window).height());
    // }, 0);
  }
  ngOnDestroy() {
    window.removeEventListener('scroll', this.fun)
  }
  //设置 nav-right 样式;
  setbar() {}
  toDetail(datainfo) {
    if (datainfo && !datainfo.experience) {
      return
    }
    this.router.navigate(['/aboutChinaIcac/detail'], {
      queryParams: { data: JSON.stringify(datainfo) },
    })
  }
  toMembershipCommittee() {
    this.router.navigate(['/aboutChinaIcac/membershipCommittee'])
  }
  touchTab(e) {
    this.currentName = e
    let obj = {
      Overview: 36,
      OrganizationalStructure: 80,
      // 'Committees': 90,
      Subcommittees: 124,
      VolunteerForChinaICAC: 168,
      ContactUs: 212,
    }
    this.top = obj[e]
    document.getElementById(e).scrollIntoView({
      behavior: 'smooth',
    })
  }
  //nav-right 元素选择;
  about(name, navBarClick) {
    const navBarItem = [
      'overview',
      'committee',
      'events-communications',
      'professional-development',
      'advisor',
      'contact-us',
    ]
    this.navRightActive = this.navRightActive.map(
      (_, index) => index === navBarItem.indexOf(name)
    )

    $('html, body')
      .stop()
      .animate(
        { scrollTop: $(`#${name}`).offset().top },
        navBarClick ? 10 : 500
      )
  }

  // go(url, title) {
  //     this.navigateService.push();
  //     this.navigateService.pushToRoute(url);
  // }

  // setFooter() {
  //     if ($('body').height() < $(window).height()){
  //         $('footer').css({"position":"fixed","bottom":"0"});
  //     } else {
  //         $('footer').css({"position":"relative","bottom":"auto"});
  //     }
  //
  //     window.onload = function() {
  //         if($('body').height() < $(window).height()){
  //             $('footer').css({"position":"fixed","bottom":"0"});
  //         } else {
  //             $('footer').css({"position":"relative","bottom":"auto"});
  //         }
  //     }
  //
  //     window.onresize = function() {
  //         if($('body').height() < $(window).height()){
  //             $('footer').css({"position":"fixed","bottom":"0"});
  //         } else {
  //             $('footer').css({"position":"relative","bottom":"auto"});
  //         }
  //     }
  // }
}



// WEBPACK FOOTER //
// /Users/apple/Documents/object/chinaicac-portal/src/app/about/about-index/about-index.component.ts